import React, { useContext, useState } from "react";
import {
	BrowserRouter,
	Routes,
	Route,
	Navigate,
	useSearchParams
} from "react-router-dom";

//componentes
import { Login } from "./components/Login.jsx";
import ConexContext from "./context/ConexContext.js";
import Layout from "./components/Layout.jsx";
import Administracion from "./components/Administracion.jsx";
import PerfilUsuario from "./components/detalles/PerfilUsuario.jsx";
import Listado from "./components/Listado.jsx";
import { RutaProtegida } from "./components/RutaProtegida.jsx";
import PerfilDepartamento from "./components/detalles/PerfilDepartamento.jsx";
import PerfilEntidad from "./components/detalles/PerfilEntidad.jsx";
import PerfilEmpresa from "./components/detalles/PerfilEmpresa.jsx";
import PerfilTarjeta from "./components/detalles/PerfilTarjeta.jsx";
import Usuarios from "./components/Usuarios.jsx";
import Departamentos from "./components/Departamentos.jsx";
import Tarjetas from "./components/Tarjetas.jsx";
import ValidarUsuario from "./components/ValidarUsuario.jsx";

const RedirectPreserveParams = () => {
	const [searchParams] = useSearchParams();
	const query = searchParams.toString();
	return <Navigate to={query ? `/?${query}` : '/'} replace />;
};

function Router() {
	const { getToken, tipo_usuario }=useContext(ConexContext);
	const [mensaje, setmensaje]= useState("");
	const [mensaje2, setmensaje2]= useState("La sesión ha caducado, por favor vuelva a iniciar sesión.");

	if(!getToken())
		return(
			<BrowserRouter>
				<Routes>
					<Route 
						path="/" 
						element={
							<Login 
								mensaje={mensaje}
								setmensaje={setmensaje}
								mensaje2={mensaje2}
							/>
						}	 
					/>
					<Route path="/validar/:usuario/:clave" element={<ValidarUsuario />} />
					<Route path="/reset/:usuario/:clave" element={<ValidarUsuario />} />
					<Route path="*" element={<RedirectPreserveParams />} />
				</Routes>
			</BrowserRouter>
		)
	else
		return(
			<BrowserRouter>
				<Routes>
					<Route path="/" element={<Layout setmensaje2={setmensaje2}/>} >
						<Route index element={<Navigate to="/listado" replace />} />
						<Route path="listado" element={<Listado />} />
						<Route path="perfil" element={<PerfilUsuario nuevo={true}/>} />
						<Route path="departamento" element={<PerfilDepartamento nuevo={true}/>} />
						<Route path="tarjeta" element={<PerfilTarjeta nuevo={true}/>} />
						<Route  path="administracion" element={<RutaProtegida componente={<Administracion />} tipo_usuario={tipo_usuario}/>} >
							<Route index element={<Navigate to="/administracion/usuarios" replace />} />
							<Route path="usuarios" element={<RutaProtegida componente={<Usuarios />} tipo_usuario={tipo_usuario}/>} />
							<Route path="departamentos" element={<RutaProtegida componente={<Departamentos />} tipo_usuario={tipo_usuario}/>} />
							<Route path="tarjetas" element={<RutaProtegida componente={<Tarjetas />} tipo_usuario={tipo_usuario}/>} />
						</Route>
						<Route path="perfil/:usuario" element={<PerfilUsuario />} />
						<Route path="departamento/:departamento" element={<PerfilDepartamento />} />
						<Route path="entidad/:entidad" element={<PerfilEntidad />} />
						<Route path="empresa/:empresa" element={<PerfilEmpresa />} />
						<Route path="tarjeta/:tarjeta" element={<PerfilTarjeta />} />
					</Route>
					<Route path="*" element={<Navigate to={'/'} />} />
				</Routes>
			</BrowserRouter>
		)
}

export default Router;
